<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-danger py-7 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Welcome!</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-secondary" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--9 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h2>Reset Password</h2>
                <small>Don't have an account? Then please <a href="/register">Register Now</a></small>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input alternative
                              class="mb-3"
                              name="Email"
                              :rules="{required: true, email: true}"
                              prepend-icon="ni ni-email-83"
                              placeholder="Email"
                              v-model="email">
                  </base-input>
                  <validation-error :errors="apiValidationErrors.email" />

                  <base-input alternative
                              class="mb-3"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              placeholder="Password"
                              v-model="password">
                  </base-input>
                  <validation-error :errors="apiValidationErrors.password" />

                  <base-input alternative
                              class="mb-3"
                              name="Confirm Password"
                              :rules="{required: true, min: 6, is:password}"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              placeholder="Confirm Password"
                              v-model="password_confirmation">
                  </base-input>
                  <validation-error :errors="apiValidationErrors.password_confirmation" />

                  <div class="text-center">
                    <base-button type="danger" native-type="submit" class="my-4" :disabled="submitted">{{ submitBtn }}</base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/forgot-password" class="text-dark"><small>Forgot password?</small></router-link>
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-dark"><small>Create new account</small></router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import ValidationError from "@/components/ValidationError.vue";
import errorsMixin from "@/mixins/errors-mixin";
import formMixin from "@/mixins/form-mixin";

export default {
  components: {
    ValidationError,
  },
  mixins: [errorsMixin, formMixin],
  data() {
    return {
      email: "",
      password: "",
      password_confirmation: "",
      submitted: false,
      token: this.$route.query.token,
    }
  },
  computed: {
    submitBtn() {
      return this.submitted ? 'Processing...' : 'Reset Password';
    }
  },
  methods: {
    async onSubmit() {
      axios.post(process.env.VUE_APP_API_BASE_URL + "/reset-password", {
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
        token: this.token
      })
      .then(response => {
        if(response.status == 200) {
          swal.fire({
            title: `Success`,
            text: response.data.message,
            showConfirmButton: false,
            timer: 3000,
            icon: 'success'
          }).then(result => {
            this.$router.push({
              path: '/'
            });
          });
        }
      })
      .catch(error => {
        this.error(error);
      });
    },
  }
};
</script>

